<template>
  <div class="player-details">
    <div class="player-details__header">
      <span v-if="playerId"
        >Selected Player ID:<q-chip color="#f4f5f7">{{ playerId }}</q-chip>
      </span>
      <span v-else
        >Selected Player ID:<q-chip color="#f4f5f7">No Player ID</q-chip></span
      >
    </div>
    <div class="player-details__content" v-if="playerId">
      <!-- Today's Performace -->
      <div class="player-details__content--item">
        <div class="heading">Today’s Performance</div>
        <div class="content" v-if="playerDetailTodayPerformance.length > 0">
          <div
            class="container"
            v-for="(item, index) in playerDetailTodayPerformance"
            :key="index"
          >
            <div class="container__row">
              <span class="subtitle">Deposits:</span>
              <span class="value"> {{ count(item.DepositsCount) }}</span>
            </div>
            <div class="container__row">
              <span class="subtitle">Deposit Value:</span>
              <span class="value">
                {{ formatCurrency(item.DepositAmount) }}</span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">Avg. Deposit:</span>
              <span class="value">
                {{ formatCurrency(item.AvgerageDeposit) }}</span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">£ Withdrawal:</span>
              <span class="value">
                {{ formatCurrency(item.WithdrawalAmount) }}</span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">Net Cash:</span>
              <span class="value"> {{ formatCurrency(item.NetCash) }}</span>
            </div>
            <div class="container__row">
              <span class="subtitle">Total Stake:</span>
              <span class="value"> {{ formatCurrency(item.TotalWager) }}</span>
            </div>
            <div class="container__row">
              <span class="subtitle">Cash Stake:</span>
              <span class="value">
                {{ formatCurrency(item.CashWager) }}
                <span class="percentage">{{
                  formatPercentageWithBrackets(item.CashWagerPercentage)
                }}</span></span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">Bonus Stake:</span>
              <span class="value">
                {{ formatCurrency(item.BonusWager) }}
                <span class="percentage">{{
                  formatPercentageWithBrackets(item.BonusWagerPercentage)
                }}</span></span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">Cash Stake : Deposits:</span>
              <span class="value">
                {{ item.CashWagerToDepositAmountRatio }}</span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">Cash Wins:</span>
              <span class="value"> {{ formatCurrency(item.CashWins) }}</span>
            </div>
            <div class="container__row">
              <span class="subtitle">GGR:</span>
              <span class="value"> {{ formatCurrency(item.GGR) }}</span>
            </div>
            <div class="container__row">
              <span class="subtitle">Bonus Awarded:</span>
              <span class="value">
                {{ formatCurrency(item.BonusAwarded) }}</span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">Awarded/Deposits:</span>
              <span class="value">
                {{
                  formatPercentage(item.BonusAwardedToDepositAmountPercentage)
                }}</span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">Bonus Converted:</span>
              <span class="value">
                {{ formatCurrency(item.BonusConverted) }}</span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">Converted/Awarded:</span>
              <span class="value">
                {{
                  formatPercentage(item.BonusConvertedToBonusAwardedPercentage)
                }}</span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">NGR:</span>
              <span class="value"> {{ formatCurrency(item.NGR) }}</span>
            </div>
            <div class="container__row">
              <span class="subtitle">NGR/Deposits:</span>
              <span class="value">
                {{ formatPercentage(item.NGRToDepositPercentage) }}</span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">Jackpot Wins</span>
              <span class="value"> {{ formatCurrency(item.JPWins) }}</span>
            </div>
          </div>
        </div>
        <div class="footer" v-else>
          <q-icon name="warning" size="sm" style="margin-right: 8px" /> No Data
        </div>
      </div>
      <!-- Lifetime Performace -->
      <div class="player-details__content--item">
        <div class="heading">Lifetime Performance</div>
        <div class="content" v-if="playerDetailLifetimePerformance.length > 0">
          <div
            class="container"
            v-for="(item, index) in playerDetailLifetimePerformance"
            :key="index"
          >
            <div class="container__row">
              <span class="subtitle">Deposits:</span>
              <span class="value"> {{ count(item.DepositsCount) }}</span>
            </div>
            <div class="container__row">
              <span class="subtitle">Deposit Value:</span>
              <span class="value">
                {{ formatCurrency(item.DepositAmount) }}</span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">Avg. Deposit:</span>
              <span class="value">
                {{ formatCurrency(item.AvgerageDeposit) }}</span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">£ Withdrawal:</span>
              <span class="value">
                {{ formatCurrency(item.WithdrawalAmount) }}</span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">Net Cash:</span>
              <span class="value"> {{ formatCurrency(item.NetCash) }}</span>
            </div>
            <div class="container__row">
              <span class="subtitle">Total Stake:</span>
              <span class="value"> {{ formatCurrency(item.TotalWager) }}</span>
            </div>
            <div class="container__row">
              <span class="subtitle">Cash Stake:</span>
              <span class="value">
                {{ formatCurrency(item.CashWager) }}
                <span class="percentage">{{
                  formatPercentageWithBrackets(item.CashWagerPercentage)
                }}</span></span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">Bonus Stake:</span>
              <span class="value">
                {{ formatCurrency(item.BonusWager) }}
                <span class="percentage">{{
                  formatPercentageWithBrackets(item.BonusWagerPercentage)
                }}</span></span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">Cash Stake : Deposits:</span>
              <span class="value">
                {{ item.CashWagerToDepositAmountRatio }}</span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">Cash Wins:</span>
              <span class="value"> {{ formatCurrency(item.CashWins) }}</span>
            </div>
            <div class="container__row">
              <span class="subtitle">GGR:</span>
              <span class="value"> {{ formatCurrency(item.GGR) }}</span>
            </div>
            <div class="container__row">
              <span class="subtitle">Bonus Awarded:</span>
              <span class="value">
                {{ formatCurrency(item.BonusAwarded) }}</span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">Awarded/Deposits:</span>
              <span class="value">
                {{
                  formatPercentage(item.BonusAwardedToDepositAmountPercentage)
                }}</span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">Bonus Converted:</span>
              <span class="value">
                {{ formatCurrency(item.BonusConverted) }}</span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">Converted/Awarded:</span>
              <span class="value">
                {{
                  formatPercentage(item.BonusConvertedToBonusAwardedPercentage)
                }}</span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">NGR:</span>
              <span class="value"> {{ formatCurrency(item.NGR) }}</span>
            </div>
            <div class="container__row">
              <span class="subtitle">NGR/Deposits:</span>
              <span class="value">
                {{ formatPercentage(item.NGRToDepositPercentage) }}</span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">Jackpot Wins</span>
              <span class="value"> {{ formatCurrency(item.JPWins) }}</span>
            </div>
          </div>
        </div>
        <div class="footer" v-else>
          <q-icon name="warning" size="sm" style="margin-right: 8px" /> No Data
        </div>
      </div>
      <!-- Total Games Played -->
      <div
        class="player-details__content--item player-details__content--item-large"
      >
        <div class="heading">Today Games Played</div>
        <q-table
          class="data-table-condensed__table"
          title-class="data-table-condensed__table--title"
          dense
          :data="rows"
          no-data-label="No Data"
          no-results-label="The filter didn't uncover any results"
          :columns="columns"
          :pagination="pagination"
          virtual-scroll
          flat
          style="height: 293px"
        >
          <template v-slot:loading>
            <q-inner-loading showing color="secondary" />
          </template>
          <template v-slot:header-cell="props">
            <q-th :props="props">
              {{ props.col.label }}
            </q-th>
          </template>
        </q-table>
      </div>
      <!-- Player Status -->
      <div
        class="player-details__content--item player-details__content--item-large"
      >
        <div class="heading">Player Status</div>
        <div class="content" v-if="playerDetailStatus.length > 0">
          <div
            class="container"
            v-for="(item, index) in playerDetailStatus"
            :key="index"
          >
            <div class="container__row">
              <span class="subtitle">Registration:</span>
              <span class="value">
                {{ formatDate(item.RegistrationDate) }}</span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">1st Deposit:</span>
              <span class="value">
                {{ formatDate(item.FirstDepositDate) }}</span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">Country:</span>
              <span class="value"> {{ item.Country }}</span>
            </div>
            <div class="container__row">
              <span class="subtitle">Player Status:</span>
              <span class="value"> {{ item.PlayerStatus }}</span>
            </div>
            <!-- <div class="container__row">
                <span class="subtitle">Last Login:</span>
                <span class="value">
                  {{ formatDateTime(item.LastLogin) }}</span
                >
              </div> -->
            <div class="container__row">
              <span class="subtitle">Bonus Abuser?</span>
              <span class="value" v-if="item.IsBonusAbuser === 0"> No</span>
              <span class="value text-red" v-if="item.IsBonusAbuser === 1">
                Yes</span
              >
            </div>
            <div class="container__row">
              <span class="subtitle">Is Contactable?</span>
              <span class="value" v-if="item.IsContactable === 0"> No</span>
              <span class="value" v-if="item.IsContactable === 1"> Yes</span>
            </div>
            <div class="container__row">
              <span class="subtitle">Balance:</span>
              <span class="value"> {{ formatCurrency(item.Balance) }}</span>
            </div>
            <div class="container__row">
              <span class="subtitle">Player Network ID:</span>
              <span class="value"> {{ item.PlayerNetworkID }}</span>
            </div>
            <div class="container__row">
              <span class="subtitle">Player Site:</span>
              <span class="value"> {{ item.Site }}</span>
            </div>
            <div class="container__row">
              <span class="subtitle">Referrer Tag:</span>
              <span class="value"> {{ hasValue(item.ReferrerTag) }}</span>
            </div>
          </div>
        </div>
        <div class="footer" v-else>
          <q-icon name="warning" size="sm" style="margin-right: 8px" /> No Data
        </div>
      </div>
    </div>
    <div class="player-details__content--placeholder" v-else>
      Please search a Player ID
    </div>
    <q-inner-loading :showing="visible">
      <q-spinner size="50px" color="secondary" />
      <span class="message"> Loading Player Details </span>
    </q-inner-loading>
  </div>
</template>

<script>
import axios from "axios";
import { formatDateTime, formatDate } from "@/utils/formatDate";
import { count } from "@/utils/formatNumbers";
import {
  formatPercentageWithBrackets,
  formatPercentage,
} from "@/utils/formatPercentage";
import { formatCurrency } from "@/utils/formatCurrency";
import { formatTextLabel, hasValue } from "@/utils/formatText";

export default {
  props: {
    playerId: Number,
  },
  data() {
    return {
      playerDetailTodayPerformance: {},
      playerDetailLifetimePerformance: {},
      playerDetailStatus: {},
      columns: [],
      keys: [],
      rows: [],
      errors: [],
      visible: false,
      interval: null,
      userId: this.$store.state.userDetails.userId,
      pagination: {
        sortBy: "desc",
        descending: true,
        rowsPerPage: 10,
      },
    };
  },
  watch: {
    playerId: function(id) {
      this.fetchData(
        null,
        this.$store.state.userDetails.networkId,
        this.$store.state.userDetails.operatorId,
        id
      );
      this.visible = true;
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.fetchData(
          null,
          this.$store.state.userDetails.networkId,
          this.$store.state.userDetails.operatorId,
          id
        );
      }, 180000);
    },
  },
  methods: {
    formatDateTime,
    formatDate,
    count,
    formatPercentageWithBrackets,
    formatPercentage,
    formatCurrency,
    hasValue,
    async fetchData(siteId, networkId, operatorId, playerId) {
      let playerDetailTodayPerformanceUrl =
        "/api/player-detail/PlayerDetail_TodayPerformance";
      let playerDetailLifetimePerformanceUrl =
        "/api/player-detail/PlayerDetail_LifetimePerformance";
      let playerDetailStatusUrl = "/api/player-detail/PlayerDetail_Status";
      let playerDetailTodayGamesUrl =
        "/api/player-detail/PlayerDetail_TodayGames";

      const token = this.$store.state.cognitoJwtToken;
      const userId = this.userId;

      const getPlayerDetailTodayPerformance = axios.post(
        playerDetailTodayPerformanceUrl,
        {
          siteId,
          networkId,
          operatorId,
          playerId,
          userId,
          token,
        }
      );
      const getPlayerDetailLifetimePerformance = axios.post(
        playerDetailLifetimePerformanceUrl,
        {
          siteId,
          networkId,
          operatorId,
          playerId,
          userId,
          token,
        }
      );
      const getPlayerDetailStatus = axios.post(playerDetailStatusUrl, {
        siteId,
        networkId,
        operatorId,
        playerId,
        userId,
        token,
      });
      const getPlayerDetailTodayGames = axios.post(playerDetailTodayGamesUrl, {
        siteId,
        networkId,
        operatorId,
        playerId,
        userId,
        token,
      });

      await axios
        .all([
          getPlayerDetailTodayPerformance,
          getPlayerDetailLifetimePerformance,
          getPlayerDetailStatus,
          getPlayerDetailTodayGames,
        ])
        .then(
          axios.spread((...responses) => {
            this.playerDetailTodayPerformance = responses[0].data;

            this.playerDetailLifetimePerformance = responses[1].data;

            this.playerDetailStatus = responses[2].data;

            if (responses[3].data[0] !== undefined) {
              const keys = Object.keys(responses[3].data[0]);
              this.columns = keys.map((key) => ({
                name: key,
                label: formatTextLabel(key),
                field: key,
                sortable: true,
                align: "left",
                format: (value) => {
                  if (key === "GameName") {
                    return value.replace(/_/g, " ");
                  } else if (
                    (key === "CashGGR" && value !== null) ||
                    (key === "BonusGGR" && value !== null)
                  ) {
                    return formatCurrency(value);
                  } else if (value !== null) {
                    return formatCurrency(value);
                  } else {
                    return `---`;
                  }
                },
              }));
            }
            this.rows = responses[3].data;
            this.visible = false;
          })
        )
        .catch((e) => {
          this.errors.push(e);
        });
    },
  },
  // Clear interval when page demounted to prevent memory leak
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss">
.player-details {
  border-radius: 4px !important;
  width: 100%;
  .q-inner-loading {
    background: rgba(255, 255, 255, 1);
    .message {
      margin-top: 1em;
      font-weight: 600;
      font-size: 14px;
      line-height: 14px;
    }
  }
  &__header {
    height: 50px;
    font-weight: 600;
    font-size: 14px;
    line-height: 14px;
    padding: 12px 15px;
    border-bottom: 0.5px solid #ececec;
    display: flex;
    align-items: center;
  }
  &__content {
    display: grid;
    padding: 20px;
    grid-template-columns: 1fr;
    column-gap: 20px;
    row-gap: 20px;
    width: 100%;
    @media only screen and (min-width: 768px) {
      grid-template-columns: 1fr 1fr;
    }
    @media only screen and (min-width: 1024px) {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    }
    @media only screen and (min-width: 1300px) {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    }
    &--item {
      height: 100%;
      grid-row: span 1;
      grid-column: span 1;
      min-width: 250px;
      min-height: 200px;
      border: 1px solid #cdcdcd;
      box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.06);
      border-radius: 4px;
      position: relative;
      @media only screen and (min-width: 768px) {
        grid-row: span 1;
        grid-column: span 1;
      }
      @media only screen and (min-width: 1024px) {
        grid-row: span 2;
        grid-column: span 1;
      }
      @media only screen and (min-width: 1300px) {
        grid-row: span 2;
        grid-column: span 1;
      }
      .heading {
        padding: 10px;
        border-bottom: 1px solid #cdcdcd;
        font-family: Barlow;
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 14px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #13110c;
      }
      .footer {
        padding: 4px 14px 4px 16px;
        border-top: 1px solid rgba(0, 0, 0, 0.12);
        font-family: Barlow;
        font-style: normal;
        font-size: 12px;
        line-height: 14px;
        display: flex;
        align-items: center;
        text-align: center;
        position: absolute;
        bottom: 0;
        width: 100%;
      }
    }
    &--item-large {
      grid-row: span 1;
      grid-column: span 1;
      @media only screen and (min-width: 768px) {
        grid-row: span 1;
        grid-column: span 2;
      }
      @media only screen and (min-width: 1024px) {
        grid-row: span 1;
        grid-column: span 3;
      }
      @media only screen and (min-width: 1300px) {
        grid-row: span 1;
        grid-column: span 3;
      }
    }
    &--placeholder {
      padding: 20px;
      height: 400px;
    }
    .container {
      &__row {
        padding: 0 10px;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-family: Barlow;
        font-weight: 500;
        font-size: 12px;
        &:nth-child(even) {
          background: #edf4fc;
        }
        &:last-child {
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
        }
        .subtitle {
          color: #030303;
        }
        .value {
          color: #747474;
          .percentage {
            margin-left: 3px;
          }
        }
      }
    }
  }
}

// Dark Mode
.body {
  &--dark {
    .player-details {
      background: #353535;
      .q-inner-loading {
        background: rgba(53, 53, 53, 1);
      }
      &__content {
        &--item {
          background: #000000;
          border: 1px solid #d3d8dd;
          box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.5);

          .heading {
            border-bottom: 1px solid #d3d8dd;
            color: #fff;
          }
          .footer {
            border-top: 1px solid #474747;
          }
        }
        .container {
          &__row {
            &:nth-child(even) {
              background: #353535;
            }
            .subtitle {
              color: #ffffff;
            }
            .value {
              color: #ffffff;
            }
          }
        }
      }
    }
  }
}
</style>
